const SvgAlertGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M8 16A8 8 0 118 0a8 8 0 010 16zm0-3a1 1 0 100-2 1 1 0 000 2zM8 3a1 1 0 00-1 1v5a1 1 0 102 0V4a1 1 0 00-1-1z' />
  </svg>
);

export default SvgAlertGlyph;
